import vars from "../../vars";

$(document).ready(function() {

	vars.$asideItem.click(function() {
		if ($(this).hasClass('selected')) {
			$(this).removeClass('selected');
		} else {
			$(this).addClass('selected');
		}
	});
});


// WEBPACK FOOTER //
// ./src/js/pages/materials/aside-select.js